function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 75.197 12.705 c -10.333 -1.879 -19.341 -5.76 -26.775 -11.534 C 47.414 0.389 46.207 -0.002 45 -0.002 c -9.265 30.337 -9.479 60.344 0 90 c 0.867 0 1.734 -0.137 2.561 -0.41 c 19.584 -6.506 32.238 -22.036 32.238 -39.566 V 18.234 C 79.799 15.516 77.863 13.19 75.197 12.705 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(56,177,119)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 15.356 12.705 c 10.333 -1.879 19.341 -5.76 26.775 -11.534 c 1.008 -0.782 2.215 -1.173 3.422 -1.173 v 90 c -0.867 0 -1.734 -0.137 -2.561 -0.41 c -19.584 -6.506 -32.238 -22.036 -32.238 -39.566 V 18.234 C 10.755 15.516 12.69 13.19 15.356 12.705 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(46,151,100)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 52.046 77.242 c -0.73 0 -1.435 -0.401 -1.786 -1.097 c -0.499 -0.986 -0.104 -2.189 0.881 -2.688 c 10.499 -5.313 16.767 -14.472 16.767 -24.501 c 0 -1.104 0.896 -2 2 -2 s 2 0.896 2 2 c 0 11.568 -7.088 22.063 -18.96 28.069 C 52.657 77.173 52.35 77.242 52.046 77.242 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(68,214,144)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20.093 35.323 c -1.104 0 -2 -0.896 -2 -2 v -8.505 c 0 -2.297 1.636 -4.262 3.889 -4.672 c 4.857 -0.883 9.342 -2.354 13.33 -4.37 c 0.984 -0.499 2.188 -0.104 2.687 0.882 c 0.499 0.985 0.104 2.188 -0.882 2.687 c -4.332 2.191 -9.183 3.784 -14.418 4.736 c -0.351 0.064 -0.605 0.374 -0.605 0.736 v 8.505 C 22.093 34.428 21.198 35.323 20.093 35.323 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(56,177,119)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 69.907 42.364 c -1.104 0 -2 -0.896 -2 -2 V 27.051 c 0 -1.104 0.896 -2 2 -2 s 2 0.896 2 2 v 13.313 C 71.907 41.469 71.012 42.364 69.907 42.364 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(68,214,144)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20.093 47.767 c -1.104 0 -2 -0.896 -2 -2 v -5.22 c 0 -1.104 0.896 -2 2 -2 s 2 0.896 2 2 v 5.22 C 22.093 46.871 21.198 47.767 20.093 47.767 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(56,177,119)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/secure.e0922ebfcca1757bd7ed2777e9fddd4b.svg";
export { ForwardRef as ReactComponent };